import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const logout = (params, urlParams) => {
  return axios.request({
    url: '/account/logout' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const hasLogined = (params, urlParams) => {
  return axios.request({
    url: '/account/haslogined' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const registerByNameAndPassword = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbynameandpassword/' + params.webVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const registerByMobilePhoneNum = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbymobilephonenum/' + params.mobileVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const registerByWechatServiceAccount = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbywechatserviceaccount/' + params.mobileVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const registerByWechatMiniProgram = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbywechatminiprogram/' + params.mobileVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const registerByWechatWebApp = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbywechatwebapp/' + params.wechatWebAppAppId + '/' + params.mobileVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const registerByWechatMobileApp = (params, urlParams) => {
  return axios.request({
    url: '/account/registerbywechatmobileapp/' + params.mobileVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByNameAndPassword = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbynameandpassword/' + params.webVerifyCode + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByMobilePhoneNum = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbymobilephonenum/' + params.mobileVerifyCode + '/' + params.mobilePhoneNum + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByWechatServiceAccount = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbywechatserviceaccount' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByWechatMiniProgram = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbywechatminiprogram' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByWebApp = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbywebapp' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByMobileApp = (params, urlParams) => {
  return axios.request({
    url: '/account/loginbymobileapp' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getSelfInfo = (params, urlParams) => {
  return axios.request({
    url: '/account/getselfinfo' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyPassword = (params, urlParams) => {
  return axios.request({
    url: '/account/modifypassword' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyPasswordBySMS = (params, urlParams) => {
  return axios.request({
    url: '/account/modifypasswordbysms' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifySelfInfo = (params, urlParams) => {
  return axios.request({
    url: '/account/modifyselfinfo' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getWebVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/account/getwebverifycode' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const checkMobileVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/account/checkmobileverifycode/' + params.mobileVerifyCode + '/' + params.mobilePhoneNum + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const checkWebVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/account/checkwebverifycode/' + params.webVerifyCode + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

